// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * Mutation to apply to the original message when all conditions match.
 */
export class ModifierAction implements flatbuffers.IUnpackableObject<ModifierActionT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifierAction {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsModifierAction(bb: flatbuffers.ByteBuffer, obj?: ModifierAction): ModifierAction {
    return (obj || new ModifierAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsModifierAction(
    bb: flatbuffers.ByteBuffer,
    obj?: ModifierAction,
  ): ModifierAction {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ModifierAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  fieldPath(): string;
  fieldPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  fieldPath(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  newValueText(): string | null;
  newValueText(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  newValueText(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startModifierAction(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addFieldPath(builder: flatbuffers.Builder, fieldPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, fieldPathOffset, 0);
  }

  static addNewValueText(builder: flatbuffers.Builder, newValueTextOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, newValueTextOffset, 0);
  }

  static endModifierAction(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // field_path
    return offset;
  }

  static createModifierAction(
    builder: flatbuffers.Builder,
    fieldPathOffset: flatbuffers.Offset,
    newValueTextOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ModifierAction.startModifierAction(builder);
    ModifierAction.addFieldPath(builder, fieldPathOffset);
    ModifierAction.addNewValueText(builder, newValueTextOffset);
    return ModifierAction.endModifierAction(builder);
  }

  unpack(): ModifierActionT {
    return new ModifierActionT(this.fieldPath(), this.newValueText());
  }

  unpackTo(_o: ModifierActionT): void {
    _o.fieldPath = this.fieldPath();
    _o.newValueText = this.newValueText();
  }

  unpackFields(...fields: string[]): ModifierActionT {
    const t = new ModifierActionT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("field_path")) {
      t.fieldPath = this.fieldPath();
    }
    if (fieldSet.has("new_value_text")) {
      t.newValueText = this.newValueText();
    }
    return t;
  }
}

export class ModifierActionT implements flatbuffers.IGeneratedObject {
  constructor(
    public fieldPath: string | Uint8Array | null = null,
    public newValueText: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.fieldPath === null || this.fieldPath === undefined) {
      throw new Error('Required field "field_path" is not set');
    }
    const fieldPath = this.fieldPath !== null ? builder.createString(this.fieldPath!) : 0;
    const newValueText = this.newValueText !== null ? builder.createString(this.newValueText!) : 0;

    return ModifierAction.createModifierAction(builder, fieldPath, newValueText);
  }

  clone(): ModifierActionT {
    const obj = new ModifierActionT();
    obj.fieldPath = this.fieldPath;
    obj.newValueText = this.newValueText;
    return obj;
  }

  equals(other: ModifierActionT): boolean {
    if (this.fieldPath !== other.fieldPath) return false;
    if (this.newValueText !== other.newValueText) return false;
    return true;
  }
}

export function verifyModifierAction(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "field_path");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
